import { render } from "./PageTitle.vue?vue&type=template&id=29e38564&ts=true"
import script from "./PageTitle.vue?vue&type=script&lang=ts"
export * from "./PageTitle.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__